<div class="card" [ngClass]="{ expanded: withTimeline(), 'is-program': isProgramOrder() }">
  @if (withProgressBar()) {
    <app-progress-bar></app-progress-bar>
  }
  @if (isProgramOrder()) {
    <div class="strip" [class.active]="withProgressBar()" (click)="onManageProgram($event)">
      <ion-icon name="accessibility-outline" />
      <div>Weight Loss Program</div>
      <ion-icon name="arrow-forward-outline" />
    </div>
  }
  <div class="head">
    <div>
      <div class="title">{{ title() }}</div>
      <div class="subtitle">{{ numItems() }}</div>
    </div>
    <app-status-tag [status]="orderStatusTag()"></app-status-tag>
  </div>
  @if (paymentError()) {
    <div class="payment-error">
      <ion-icon name="warning" />
      <div>
        Payment declined.
        <a (click)="onManageProgram($event)">Please check your payment details</a>
      </div>
    </div>
  } @else if (withDelivery()) {
    <div class="delivery">
      <div class="label">{{ deliveryLabel() }}</div>
      <div class="value" (click)="onClickDelivery()">{{ deliveryValue() }}</div>
    </div>
  }
  @if (fulfillmentMethod() && orderStatus() === 'Approved') {
    <app-countdown mode="order" [orderId]="order().id" [roundedBtm]="!withTimeline() && !hasViewOrder() && !hasCollectionPin() && !hasPaymentButton()" />
  }
  @if (withTimeline()) {
    <app-order-card-timeline [title]="timelineTitle()" [rows]="timelineRows()" />
  }
  @if (hasViewOrder()) {
    <div class="action" (click)="onClickViewOrder()">
      <div>View Order</div>
      <ion-icon name="receipt-outline"></ion-icon>
    </div>
  } @else if (hasCollectionPin()) {
    <div class="action">
      <app-button label="Collection PIN" (click)="onClickCollectionPin($event)" />
    </div>
  } @else if (hasPaymentButton()) {
    <div class="action">
      <app-button [label]="paymentButtonLabel()" [disabled]="isPaying()" (click)="onPay($event)" />
    </div>
  }
</div>
